import { Component, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'ui-form-panel',
  templateUrl: './ui-form-panel.component.html',
  styleUrls: ['./ui-form-panel.component.scss']
})
export class UiFormPanelComponent {
  @Input() isEditing: boolean = false;
  @Input() readOnly: boolean = true;
  @Input() canSave: boolean = true;
  @Input() useSaveIcon: boolean = true;
  @Input() saveButtonTitle: string = "save";
  @Input() buttonLabel: string = '';
  @Input() disableCancel: boolean = false;
  @Input() showSaveCancel: boolean = true;
  @Input() helpMsgText: string;
  @Output() editClick = new EventEmitter(); 
  @Output() saveClick = new EventEmitter();
  @Output() cancelClick = new EventEmitter();

  constructor() {

  }

  onEditClick() {
    this.editClick.emit();
  }

  onSaveClick() {
    this.saveClick.emit();
  }

  onCancelClick() {
    this.cancelClick.emit();
  }
}
